/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Spoznávajte ľudí, chatujte a zabávajte sa",
      "Zadané telefónne číslo je nesprávne",
      "Get the app",
      "Pokračovať cez Apple",
      "Pokračovať cez Facebook",
      "Pokračovať cez Google",
      "Prihlásenie",
      "Registrácia",
      "Ak chcete pokračovať, zadajte do poľa zobrazené znaky.",
      "Pokračovať",
      "Zadajte znaky",
      "Bezpečnostná kontrola",
      "Znova načítať",
      "Vytvorte si nové heslo, ktoré si ľahko zapamätáte:",
      "Aktualizovať",
      "Potvrdiť heslo",
      "Heslo musí obsahovať aspoň {{num}} [[characters:num]]",
      "Heslo",
      "Vytvorenie nového hesla",
      "Badoo – Blog",
      "Kariéra",
      "Chat",
      "Mestá",
      "Spravovať súbory cookie",
      "Copyright © 2006 – súčasnosť. Bumble. Všetky práva vyhradené.",
      "Apple a logo Apple sú ochrannými známkami spoločnosti Apple Inc.{{__EOL__}}Google Play je ochrannou známkou spoločnosti Google LLC.",
      "Na stiahnutie",
      "Facebook",
      "Sledujte nás",
      "Centrum pomoci",
      "Instagram",
      "Jazyk",
      "LinkedIn",
      "Prehľad",
      "Badoo je súčasťou Bumble Inc.",
      "Pravidlá ochrany osobných údajov",
      "Safety Centre",
      "Mapa webu",
      "Zákon o modernom otroctve – vyhlásenie",
      "Podmienky služby",
      "Twitter",
      "Zadajte svoj e‑mail alebo telefónne číslo a my vám pošleme pokyny na vytvorenie nového hesla.",
      "Získať nové heslo",
      "Zadajte svoj e‑mail alebo telefónne číslo",
      "Zabudnuté heslo",
      "Modelky a modeli slúžia len na ilustračné účely",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nemusíte čakať na vzájomnú sympatiu.{{__EOL__}}{{__EOL__}}Preskočte priamo do konverzácie, ktorá vás zavedie ďalej, hlbšie a priamo k tomu najlepšiemu. Veď viete. Tam, kde sa skutočne spoznáte.",
      "Ste pripravení četovať?",
      "Registráciou vyjadrujete súhlas s našimi <a class=\"link\" href=\"{{terms_url}}\">podmienkami</a>. V našich <a class=\"link\" href=\"{{privacy_url}}\">pravidlách ochrany osobných údajov si môžete prečítať, ako používame vaše údaje.</a>",
      "Pomáhame vám, aby ste do zoznamovania mohli vkladať <br />viac svojho skutočného ja a cítili sa dobre.",
      "Verte si pri zoznamovaní",
      "alebo",
      "Už máte účet?",
      "Zaregistrujte sa pomocou e‑mailu  alebo telefónneho čísla",
      "Za svoje očakávania a túžby{{__EOL__}} sa nikdy nemusíte ospravedlňovať.",
      "Chcete sa len porozprávať? V poriadku.{{__EOL__}}Chcete sa usadiť? Môže byť.{{__EOL__}}{{__EOL__}}Rozmysleli ste si to? Žiadny problém.",
      "Chcem ísť na rande",
      "Sú pripravení na vzťah",
      "Len chat",
      "Zoznamujte sa s ľuďmi, ktorí hľadajú to isté.",
      "{{name}}, {{age}}",
      "Vaša bezpečnosť je našou najvyššou prioritou.",
      "Naše Safety Centre je plné praktických rád, kde nájdete podporu, ktorú potrebujete pri zoznamovaní.",
      "Navštívte naše Safety Centre",
      "Bezpečnosť na prvom mieste,<br/>na druhom a jednoducho vždy.",
      "Hneď od prvej chvíle som vedel, že to bude klapať…",
      "Zo začiatku som nehľadala nič vážne…",
      "Všetkým, ktorí používajú aplikáciu Badoo, by som poradil jedno: buďte sami sebou...",
      "Príbehy úspechu na Badoo",
      "Pozrite si ďalšie príbehy úspechu",
      "Hodnotenie__CUT__{{num}}",
      "Apple App Store",
      "Spoľahnite sa na nás. Od roku 2006 sme zoznámili už milióny a milióny (a milióny) ľudí.",
      "Viac než {{num}} mil.__CUT__stiahnutí",
      "Viac než {{num}} mil.",
      "Google Play Store",
      "Vieme, čo robíme.",
      "Prihláste sa pomocou e‑mailu alebo telefónneho čísla",
      "Zadajte svoje heslo",
      "Zabudli ste heslo?",
      "Zaregistrujte sa",
      "Nemáte účet?",
      "Prihlásenie",
      "Registrácia"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "znaky",
                  "znakov",
                  "znakom",
                  "znaky",
                  "znakoch",
                  "znakmi"
            ],
            "many": [
                  "znakov",
                  "znakov",
                  "znakom",
                  "znakov",
                  "znakoch",
                  "znakmi"
            ],
            "plural": [
                  "znakov",
                  "znakov",
                  "znakom",
                  "znakov",
                  "znakoch",
                  "znakmi"
            ],
            "singular": [
                  "znak",
                  "znaku",
                  "znaku",
                  "znak",
                  "znaku",
                  "znakom"
            ]
      },
      "day": {
            "few": [
                  "dni",
                  "dní",
                  "dňom",
                  "dni",
                  "dňoch",
                  "dňami"
            ],
            "many": [
                  "dní",
                  "dní",
                  "dňom",
                  "dní",
                  "dňoch",
                  "dňami"
            ],
            "plural": [
                  "dní",
                  "dní",
                  "dňom",
                  "dní",
                  "dňoch",
                  "dňami"
            ],
            "singular": [
                  "deň",
                  "dňa",
                  "dňu",
                  "deň",
                  "dni",
                  "dňom"
            ]
      },
      "hour": {
            "few": [
                  "hodiny",
                  "hodín",
                  "hodinám",
                  "hodiny",
                  "hodinách",
                  "hodinami"
            ],
            "many": [
                  "hodín",
                  "hodín",
                  "hodinám",
                  "hodín",
                  "hodinách",
                  "hodinami"
            ],
            "plural": [
                  "hodín",
                  "hodín",
                  "hodinám",
                  "hodín",
                  "hodinách",
                  "hodinami"
            ],
            "singular": [
                  "hodina",
                  "hodiny",
                  "hodine",
                  "hodinu",
                  "hodine",
                  "hodinou"
            ]
      },
      "minute": {
            "few": [
                  "minúty",
                  "minút",
                  "minútam",
                  "minúty",
                  "minútach",
                  "minútami"
            ],
            "many": [
                  "minút",
                  "minút",
                  "minútam",
                  "minút",
                  "minútach",
                  "minútami"
            ],
            "plural": [
                  "minút",
                  "minút",
                  "minútam",
                  "minút",
                  "minútach",
                  "minútami"
            ],
            "singular": [
                  "minúta",
                  "minúty",
                  "minúte",
                  "minútu",
                  "minúte",
                  "minútou"
            ]
      },
      "month": {
            "few": [
                  "mesiace",
                  "mesiacov",
                  "mesiacom",
                  "mesiace",
                  "mesiacoch",
                  "mesiacmi"
            ],
            "many": [
                  "mesiacov",
                  "mesiacov",
                  "mesiacom",
                  "mesiacov",
                  "mesiacoch",
                  "mesiacmi"
            ],
            "plural": [
                  "mesiacov",
                  "mesiacov",
                  "mesiacom",
                  "mesiacov",
                  "mesiacoch",
                  "mesiacmi"
            ],
            "singular": [
                  "mesiac",
                  "mesiaca",
                  "mesiacu",
                  "mesiac",
                  "mesiaci",
                  "mesiacom"
            ]
      },
      "second": {
            "few": [
                  "sekundy",
                  "sekúnd",
                  "sekundám",
                  "sekundy",
                  "sekundách",
                  "sekundami"
            ],
            "many": [
                  "sekúnd",
                  "sekúnd",
                  "sekundám",
                  "sekúnd",
                  "sekundách",
                  "sekundami"
            ],
            "plural": [
                  "sekúnd",
                  "sekúnd",
                  "sekundám",
                  "sekúnd",
                  "sekundách",
                  "sekundami"
            ],
            "singular": [
                  "sekunda",
                  "sekundy",
                  "sekunde",
                  "sekundu",
                  "sekunde",
                  "sekundou"
            ]
      },
      "year": {
            "few": [
                  "roky",
                  "rokov",
                  "rokom",
                  "roky",
                  "rokoch",
                  "rokmi"
            ],
            "many": [
                  "rokov",
                  "rokov",
                  "rokom",
                  "rokov",
                  "rokoch",
                  "rokmi"
            ],
            "plural": [
                  "rokov",
                  "rokov",
                  "rokom",
                  "rokov",
                  "rokoch",
                  "rokmi"
            ],
            "singular": [
                  "rok",
                  "roka",
                  "roku",
                  "rok",
                  "roku",
                  "rokom"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
